import { Navigate, useParams } from "react-router-dom";

import { WorkspaceTabs } from "../../components/ui/WorkspaceTabs";
import { t } from "../../lib/i18n";
import { AuditLogPage } from "../audit/AuditLogPage";
import { EnrollmentListPage } from "../enrollment/EnrollmentListPage";
import { ScheduledReportsPage } from "../scheduledReports/ScheduledReportsPage";
import { SettingsPage } from "../settings/SettingsPage";
import { UsersListPage } from "../users/UsersListPage";

const TAB_VALUES = ["users", "enrollment", "audit", "settings", "reports"] as const;
type ConfigTab = (typeof TAB_VALUES)[number];

export function ConfigurationWorkspace() {
  const { tab } = useParams<{ tab?: string }>();
  const active = (TAB_VALUES as readonly string[]).includes(tab ?? "")
    ? (tab as ConfigTab)
    : null;

  if (!active) {
    return <Navigate to="/config/users" replace />;
  }

  const tabs = TAB_VALUES.map((value) => ({
    value,
    label: t(`config.tabs.${value}`),
  }));

  return (
    <div className="stack">
      <WorkspaceTabs<ConfigTab>
        tabs={tabs}
        value={active}
        basePath="/config"
        ariaLabel={t("config.title")}
      />
      {active === "users" && <UsersListPage />}
      {active === "enrollment" && <EnrollmentListPage />}
      {active === "audit" && <AuditLogPage />}
      {active === "settings" && <SettingsPage />}
      {active === "reports" && <ScheduledReportsPage />}
    </div>
  );
}
